

















import Vue from 'vue';
import { layouts, layoutColumn } from './layoutTemplates';

export default Vue.extend({
  name: 'LoadingState',
  props: {
    layoutType: {
      type: String,
      default: null,
    },
  },
  data() {
    const name = this.layoutType || this.$parent.$options.name || 'default';

    return { layout: layouts[name] as layoutColumn[] };
  },
  methods: {
    randWidth(randomize: string): string {
      if (!randomize) {
        return '';
      } else {
        return `width: ${Math.floor(Math.random() * 31) + 70}%`;
      }
    },
  },
});
